class StatsCarousel extends window.BAO.Carousel.Element {
  initialiseCarousel () {
    const next = this.els.next?.element
    const previous = this.els.previous?.element

    return new window.KeenSlider(
      this.els.slides.element,
      {
        selector: this.els.slide.selector,
        defaultAnimation: {
          duration: 1500,
        },
        loop: true,
        mode: 'snap',
        slides: {
          perView: 1,
          disabled: Number(this.dataset.slideCount) <= 1,
        },
        breakpoints: {
          [`(min-width: ${window.BAO.MediaBreakpoints.breakpoints.sm}px)`]: {
            disabled: true,
          },
        },
      },
      [
        window.BAO.Carousel.useInitialised(),
        window.BAO.Carousel.useArrows({ next, previous }),
      ],
    )
  }
}

if (!customElements.get('stats-carousel')) {
  customElements.define('stats-carousel', StatsCarousel)
}
